import { render, staticRenderFns } from "./card.vue?vue&type=template&id=378ab784&scoped=true"
import script from "./card.vue?vue&type=script&lang=js"
export * from "./card.vue?vue&type=script&lang=js"
import style1 from "./card.vue?vue&type=style&index=1&id=378ab784&prod&lang=scss"
import style2 from "./card.vue?vue&type=style&index=2&id=378ab784&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378ab784",
  null
  
)

export default component.exports